export type ApiResponse<T> = {
  isError: boolean;
  message: string;
  data: T;
};

export class ApiError extends Error {
  readonly data: unknown;

  constructor(message: string, data: unknown = null) {
    super(message);
    this.name = "ApiError";
    this.data = data;
  }
}

export class HttpError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "HttpError";
    this.status = status;
  }
}
